import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/Auth";
import { Outlet, Navigate } from "react-router-dom";
import axios from "axios";
import Spinner from "../Spinner";

export default function PrivateRoute() {
  const [auth] = useAuth();
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const authCheck = async () => {
      // Agar token hi nahi hai -> seedha reject
      if (!auth?.token) {
        setOk(false);
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get(
          "https://portfoliomern-mxue.onrender.com/api/v1/auth/user-auth",
          {
            headers: { Authorization: `Bearer ${auth.token}` },
          }
        );
        console.log("project auth token", auth?.token);
        setOk(res.data.ok);
      } catch (error) {
        console.error("Auth check failed:", error);
        setOk(false);
      } finally {
        setLoading(false);
      }
    };

    authCheck();
  }, [auth?.token]);

  if (loading) return <Spinner path="login" />;

  // Agar ok true -> allow else redirect to login
  return ok ? <Outlet /> : <Navigate to="/login" replace />;
}
